// @styles
require('./amazonGiftCardCoupons.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { EmptyState } = require('commonsComponents/emptyState');
const { LastMovementsTable } = require('commonsComponents/lastMovementsTable');
const { CategoriesModal } = require('components/commons/categoriesModal/categoriesModal');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKLink } = require('commonsComponents/OKLink');
const { OKMessage } = require('commonsComponents/OKMessage');

// @utilities
const { PAGE_NAMES, SECTION_NAME, BUTTON_TAGS } = require('utilities/taggingAmazonCouponCodeHelper');
const { findActiveFilters } = require('utilities/filtersHelper');

// @components
const AmazonCouponCodeTableRow = require('./amazonCouponCodeTableRow');
const AmazonCouponCodeFilter = require('./amazonCouponCodeFilter');
const AmazonCouponCodeContentFilter = require('./amazonCouponCodeContentFilter');

// @helpers
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const { getPublicSiteUrl } = require('core/apiURLBuilder');

// @ constants
const { LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY } = require('constants/commonsComponents');
const language = getLanguage();
const { COUNTRY_CODE_ES } = require('commonsConstants/countryCodes');
const {
    AMAZON_CODIGOS,
    AMAZON_GIFT_CARD_TIPO_PROCESS,
    AMAZON_GIFT_CARD_HIRING_REINTENTAR,
    AMAZON_GIFT_CARD_HIRING_COMPRAR
} = require('constants/tagging');

//@utils
const { recordProcess, recordLinkV2 } = require("utilities/tagging");

class AmazonGiftCardCoupons extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            filterSettingsOpen: false
        };
        this.handleFilterBtnClick = this.handleFilterBtnClick.bind(this);
        this.handleToggleFilters = this.handleToggleFilters.bind(this);
        this.buildNextPageButton = this.buildNextPageButton.bind(this);
        this.handleRetryClick = this.handleRetryClick.bind(this);
        this.handleNextPage = this.handleNextPage.bind(this);
        this.setFilters = this.setFilters.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.resetFilter = this.resetFilter.bind(this);
    }

    componentDidMount() {
        recordProcess(
            AMAZON_GIFT_CARD_TIPO_PROCESS,
            '',
            {
                processDetail: "cheque-regalo-de-amazon",
                nombrePagina: AMAZON_CODIGOS
            },
            true
        )
    }

    setFilters(filters) {
        const { getAmazonCouponCodeInfo, setFilters } = this.props;
        setFilters(filters);
        getAmazonCouponCodeInfo();
    }

    resetFilter(filter) {
        const { getAmazonCouponCodeInfo, resetFilter } = this.props;
        resetFilter(filter);
        getAmazonCouponCodeInfo();
    }

    clearFilters() {
        const { clearFilters, getAmazonCouponCodeInfo } = this.props;
        clearFilters();
        getAmazonCouponCodeInfo();
    }

    handleRetryClick() {
        const { getAmazonCouponCodeInfo } = this.props;
        getAmazonCouponCodeInfo();
        const customData = ({
            categoriaEvento: AMAZON_CODIGOS,
            accionEvento: AMAZON_GIFT_CARD_HIRING_REINTENTAR
        });
        recordLinkV2(customData);
    }

    handleToggleFilters() {
        this.setState(previousState => {
            return {
                filterSettingsOpen: !previousState.filterSettingsOpen
            }
        });
    }

    handleFilterBtnClick() {
        this.handleToggleFilters();
        const customData = ({
            categoriaEvento: AMAZON_CODIGOS,
            accionEvento: "filtrar codigos",
            etiquetaEvento: "filtro"
        });
        recordLinkV2(customData);
    }

    handleNextPage() {
        const { requestNextAmazonCouponCodeInfoPage } = this.props;
        requestNextAmazonCouponCodeInfoPage();
    }

    handleBackNavigationToPromotions() {
        const publicPromotionsPath = getLanguage().toLowerCase() === COUNTRY_CODE_ES.toLowerCase() ? '/ofertas-bancarias' : '/en/bank-promotions';
        let publicSiteUrl = getPublicSiteUrl();
        if (!!publicSiteUrl && publicSiteUrl.slice(publicSiteUrl.length - 3, -2) === "/") {
            publicSiteUrl = publicSiteUrl.slice(0, -3);
        }
        const publicPromotionsLink = `${publicSiteUrl}${publicPromotionsPath}`;
        window.location.href = publicPromotionsLink;
        const customData = ({
            categoriaEvento: AMAZON_CODIGOS,
            accionEvento: "ir a promociones y descuentos"
        });
        recordLinkV2(customData);
    }

    buildNextPageButton() {
        return (
            <footer className="text-right amazon-gift-card-coupons__more-button-container">
                <OKLink modifier="emphasize" onClick={this.handleNextPage}>
                    <FormattedText value="amazonGiftCard-seeMore" />
                </OKLink>
            </footer>
        );
    }

    buildVoucherCodeInfo() {
        return (
            <div className="amazon-gift-card-coupons__voucher-code-info">
                <OKMessage type="informative">
                    {formatText('amazonGiftCard-voucherCodeTooltipContent')}
                </OKMessage>
            </div>
        )
    }

    buildAmazonCouponCodeTable() {
        const { accountId, immAmazonGiftCard } = this.props;
        let headerButtons;
        let response;
        let buyAmazonGiftCardlink = `/myprofile/accounts/${accountId}/buy-amazon-gift-card`;
        let nextPageButton;

        let nextPageLoadingSection;

        if (immAmazonGiftCard.get('isFetchingNextPage')) {
            nextPageLoadingSection = <LoadingSection />;
        }else if(immAmazonGiftCard.get('nextPage')) {
            nextPageButton = this.buildNextPageButton();
        }else {
            nextPageButton = null;
        }
        let immAmazonGiftCardByOrder = immAmazonGiftCard.get('byOrder');
        const immAmazonGiftCardById = immAmazonGiftCard.get('byId');
        const immAmazonGiftCardFilters = immAmazonGiftCard.get('filters');
        const promotionAd = immAmazonGiftCard.get('promotionAd');
        let buyGiftVoucherButton;
        let buyVoucherButton;
        let noPromotionButton;

        if ((immAmazonGiftCardByOrder.size > 0 || findActiveFilters(immAmazonGiftCardFilters)) && promotionAd.size > 0) {
            buyGiftVoucherButton = (
                <span className="amazon-gift-card-coupons__buy-coupon">
                    <OKButton
                        to={buyAmazonGiftCardlink}
                        modifier="ghost"
                        leftIcon="icon-agregar"
                        title={BUTTON_TAGS.BUY_GIFT_CARD}
                        onClick={() => {
                            const customData = ({
                                categoriaEvento: AMAZON_CODIGOS,
                                accionEvento: "comprar cheque regalo",
                                etiquetaEvento: AMAZON_GIFT_CARD_HIRING_COMPRAR
                            });
                            recordLinkV2(customData);
                        }}
                    >
                        <FormattedText value="amazonGiftCard-buyGiftVoucher" />
                    </OKButton>
                </span>
            );
        } else if (immAmazonGiftCardByOrder.size === 0 && promotionAd.size === 0) {
            noPromotionButton = (
                <div className="amazon-gift-card-coupons__no-promotion-button">
                    <OKButton
                        onClick={this.handleBackNavigationToPromotions}
                        modifier="secondary">
                        <FormattedText value="amazonGiftCard-noPromotionsButtonText" />
                    </OKButton>
                </div>
            );
        } else {
            buyVoucherButton = (
                <div
                    className="amazon-gift-card-coupons__buy-coupon-button"
                >
                    <OKButton
                        to={buyAmazonGiftCardlink}
                        modifier="secondary"
                        size="regular"
                        title={BUTTON_TAGS.BUY_GIFT_CARD}
                        onClick={() => {
                            const customData = ({
                                categoriaEvento: AMAZON_CODIGOS,
                                accionEvento: "comprar cheque regalo"
                            });
                            recordLinkV2(customData);
                        }}
                    >
                        <FormattedText value="amazonGiftCard-buyGiftVoucher" />
                    </OKButton>
                </div>
            );
        }

        headerButtons = (
            <div
                className="amazon-gift-card-coupons__buy-voucher"
                data-gtns-component-name={`${SECTION_NAME} - ${PAGE_NAMES.COUPON_CODES}`}
            >
                {buyGiftVoucherButton}
                <OKButton modifier="task" onClick={this.handleFilterBtnClick}>
                    <i className="icon icon-filtrar amazon-gift-card-coupons__filter-settings-icon" />
                </OKButton>
            </div>
        );
        if (immAmazonGiftCardByOrder.size > 0) {
            const voucherCodeInfo = this.buildVoucherCodeInfo();
            response = (
                <div>
                    {voucherCodeInfo}
                    {headerButtons}
                    <AmazonCouponCodeContentFilter
                        immFilter={immAmazonGiftCardFilters}
                        resetFilter={this.resetFilter}
                        clearFilters={this.clearFilters}
                    />
                    <section className="amazon-gift-card-coupons__table">
                        <CategoriesModal />
                        <LastMovementsTable
                            groupByDate={true}
                            rowComponent={AmazonCouponCodeTableRow}
                            immTransactionsByOrder={immAmazonGiftCardByOrder}
                            immTransactionsById={immAmazonGiftCardById}
                            id={'amazon-giftCard-table'}
                            onRowClick={this.props.onRowClick}
                            groupHeaderClassName={'account-last-movements-table__group-header'}
                            columnsCount={5}
                            currentMonthKey={LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY}
                            language={language}
                        >
                            <thead>
                                <OKTableRow asHeader={true}>
                                    <OKTableCell asHeader={true}>
                                        <FormattedText value="amazonGiftCard-date" />
                                    </OKTableCell>
                                    <OKTableCell asHeader={true}>
                                        <FormattedText value="amazonGiftCard-promoName" />
                                    </OKTableCell>
                                    <OKTableCell className="amazon-gift-card-coupons__table-cell-codigo" asHeader={true}>
                                        <FormattedText value="amazonGiftCard-code" />
                                    </OKTableCell>
                                    <OKTableCell className="amazon-gift-card-coupons__table-cell-last" asHeader={true}>
                                        <FormattedText value="amazonGiftCard-gift" />
                                    </OKTableCell>
                                </OKTableRow>
                            </thead>
                        </LastMovementsTable>
                        {nextPageLoadingSection}
                        {nextPageButton}
                    </section>
                </div>
            );
        } else {
            if (findActiveFilters(immAmazonGiftCardFilters)) {
                response = (
                    <div>
                        {headerButtons}
                        <AmazonCouponCodeContentFilter
                            immFilter={immAmazonGiftCardFilters}
                            resetFilter={this.resetFilter}
                            clearFilters={this.clearFilters}
                        />
                        <div className="amazon-gift-card-coupons__empty-state">
                            <EmptyState primaryText={formatText('amazonGiftCard-couponsFilterEmpty')} iconType="search-banking" />
                        </div>
                    </div>
                );

            } else if (immAmazonGiftCardByOrder.size === 0 && promotionAd.size === 0) {
                response = (
                    <div className="amazon-gift-card-coupons__empty-state">
                        <EmptyState primaryText={formatText('amazonGiftCard-noPromotionsWithNoCoupen')} iconType="financiation-banking" />
                        {noPromotionButton}
                    </div>
                );
            } else {
                response = (
                    <div className="amazon-gift-card-coupons__empty-state">
                        <EmptyState primaryText={formatText('amazonGiftCard-noCoupon')} iconType="financiation-banking" />
                        {buyVoucherButton}
                    </div>
                );
            }
        }
        return (
            <section className="amazon-gift-card-coupons__content">
                {response}
            </section>
        );
    }

    render() {
        const { 
            accountId,
            immAmazonGiftCard,
        } = this.props;
        let content;
        if (immAmazonGiftCard.get('couponCodeIsFetching')) {
            content = (<LoadingSection />);
        } else if (immAmazonGiftCard.get('amazonCouponCodeError')) {
            const retryButton = (
                <OKButton onClick={this.handleRetryClick}
                    modifier="secondary"
                >
                    <FormattedText value="common-retry" />
                </OKButton>
            );
            content = (
                <div className="amazon-gift-card-coupons__empty-state">
                    <EmptyState 
                        primaryText={formatText('amazonGiftCard-connectionError')}
                        secondaryText={formatText('amazonGiftCard-connectionErrorDescription')}
                        button={retryButton}
                        iconType="nointernet-banking" />
                </div>
            );
        } else if (immAmazonGiftCard.get('amazonCouponCodeSuccess')) {
            content = this.buildAmazonCouponCodeTable();
        }
        else {
            content = (
                <div className="amazon-gift-card-coupons__empty-state">
                    <EmptyState primaryText={formatText('amazonGiftCard-noCoupon')} iconType="search-banking" />
                    <div
                        className="amazon-gift-card-coupons__buy-voucher-btn-wrapper"
                        data-gtns-component-name={`${SECTION_NAME} - ${PAGE_NAMES.COUPON_CODES}`}
                    >
                        <OKButton
                            to={`/myprofile/accounts/${accountId}/buy-amazon-gift-card`}
                            modifier="secondary"
                            size="regular"
                            title={BUTTON_TAGS.BUY_GIFT_CARD}>
                            <FormattedText value="amazonGiftCard-buyGiftVoucher" />
                        </OKButton>
                    </div>
                </div>
            );
        }
        return (
            <div className="amazon-gift-card-coupons">
                <AmazonCouponCodeFilter
                    immFilter={immAmazonGiftCard.get('filters')}
                    isOpen={this.state.filterSettingsOpen}
                    onCloseClick={this.handleToggleFilters}
                    setFilters={this.setFilters}
                />
                {content}
            </div>
        );
    }
}

AmazonGiftCardCoupons.propTypes = {
    accountId: PropTypes.string,
    clearFilters: PropTypes.func.isRequired,
    getAmazonCouponCodeInfo: PropTypes.func.isRequired,
    immAmazonGiftCard: PropTypes.object.isRequired,
    onRowClick: PropTypes.func.isRequired,
    resetFilter: PropTypes.func.isRequired,
    requestNextAmazonCouponCodeInfoPage: PropTypes.func.isRequired,
    setFilters: PropTypes.func.isRequired,
};

module.exports = AmazonGiftCardCoupons;
